import type { CountryCode } from 'libphonenumber-js';

import { flag, flagImage } from './Flag.css';

interface FlagProps {
  countryCode: CountryCode;
}

const Flag: React.FC<React.PropsWithChildren<FlagProps>> = ({ countryCode }) => {
  const countryCodeLower = countryCode.toLowerCase();
  return (
    <div className={flag}>
      <img className={flagImage} src={`https://flagcdn.com/w80/${countryCodeLower}.png`} alt={countryCode} />
    </div>
  );
};

export default Flag;
